import React from "react";
import { Typography } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectIsDevEnvironment } from "@tailormed/common-client/store/selector";

import { selectEnvironment } from "../store/selector";
import { GOLD } from "../constant/colors";

const { Text } = Typography;

const EnvironmentHeader = () => {
  const { t } = useTranslation();
  const environment = useSelector(selectEnvironment);
  const isDevEnvironment = useSelector(selectIsDevEnvironment);

  if (!environment || !isDevEnvironment) return null;

  return (
    <div style={{ backgroundColor: GOLD, textAlign: "center" }}>
      <Text>{t("environment_header", { environment })}</Text>
    </div>
  );
};

export { EnvironmentHeader };
